import { CalendarEventsRecurrenceService } from './calendar-events-recurrence.service';

export default angular
  .module('sfMobile.services.calendar-events-recurrence', [
    'sfMobile.services.action-sheet',
    'sfMobile.constants.calendar-events-recurrence-choices',
  ])
  .service('calendarEventsRecurrenceService', CalendarEventsRecurrenceService)
  .name;
